module.exports = __webpack_public_path__ + "img/member.c6a2afd7.png";